import { FC } from "react";
import { IEsimSmdpTimelineEntry } from "../../../interfaces/esim/EsimDiagnostics.types";
import { formatDateTimeSq } from "../../../utils/esim/format";

const SmdpTimeline: FC<{ entries: IEsimSmdpTimelineEntry[] }> = ({ entries }) => {
  if (!entries?.length) return null;

  return (
    <div className="bg-white p-4 rounded-lg shadow-sm">
      <h3 className="text-sm font-semibold text-gray-700 mb-3">
        Historiku i profilit (SM-DP+)
      </h3>
      <ol className="relative border-l border-gray-200 ml-2">
        {entries.map((entry, index) => (
          <li key={`${entry.status}-${index}`} className="ml-4 pb-4 last:pb-0">
            <div className="absolute -left-1.5 w-3 h-3 rounded-full bg-secondary" />
            <p className="text-sm font-medium text-gray-800">
              {entry.statusDisplay || entry.status}
            </p>
            <p className="text-xs text-gray-500">
              {formatDateTimeSq(entry.startUtc)}
              {entry.endUtc ? ` → ${formatDateTimeSq(entry.endUtc)}` : " → në vazhdim"}
            </p>
            {entry.profileType && (
              <p className="text-[11px] text-gray-400">{entry.profileType}</p>
            )}
          </li>
        ))}
      </ol>
    </div>
  );
};

export default SmdpTimeline;
